/* tslint:disable */
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HttpResponse} from '@angular/common/http';
import {Inject} from '@angular/core';
import {Injectable} from '@angular/core';
import {API_HOST} from '../api-host';
import {PostOrderResponse} from './post-order.response';
import {PostOrderRequest} from './post-order.request';
@Injectable()
export class OrderGateway {
  constructor(private readonly _httpClient: HttpClient, @Inject(API_HOST) private readonly _apiHost: string) {}

  postOrder(body: PostOrderRequest, options?: Parameters<HttpClient['request']>[2]): Observable<PostOrderResponse> {
    return this._httpClient.request('post', this._apiHost + '/order', {
      ...options,
      observe: 'body',
      body,
    });
  }
}
